












































import Vue from 'vue';
import { mapGetters } from 'vuex';
import SquareEditOutlineIcon from 'vue-material-design-icons/SquareEditOutline.vue';
import pxCard from '@/dex-shared/components/px-card.vue';
import Content from '@/dex-shared/components/new_content/Content.vue';
import AdminListItemModel from '@/models/AdminListItemModel';

export default Vue.extend({
  components: {
    pxCard,
    SquareEditOutlineIcon,
    Content,
  },

  props: {
    listItemId: {
      type: Number,
      required: true,
    },
  },

  computed: {
    ...mapGetters({
      listItemById: 'listItemById',
    }),
    listItem(): AdminListItemModel {
      return this.listItemById(this.listItemId);
    },
    listLength(): number {
      return this.listItem.list().listItems().length;
    },
    position(): number {
      return this.listItem.position + 1;
    },
    type(): string {
      if (this.listItem.questionId) {
        return 'Questão';
      }
      if (this.listItem.articleId) {
        return 'Explicação';
      }
      if (this.listItem.videoId) {
        return 'Vídeo';
      }
      return '';
    },
  },

  methods: {
    shiftPositions(listItemsToModify: AdminListItemModel[], offset: number) {
      listItemsToModify.forEach((listItem: AdminListItemModel) => {
        this.$store.commit('UPDATE_ENTITY_PROP', {
          id: listItem.id,
          entity: 'list_items',
          propToUpdate: 'position',
          value: listItem.position + offset,
        });
      });
    },
    moveItem(e: Event) {
      const newPosition = +(e.target as HTMLInputElement).value - 1;
      const oldPosition = this.listItem.position;
      const listItems = this.listItem.list().listItems();
      if (newPosition > oldPosition) {
        const listItemsToModify = listItems
          .slice(oldPosition, newPosition + 1)
          .filter(
            (listItem: AdminListItemModel) => listItem.id != this.listItem.id,
          );
        this.shiftPositions(listItemsToModify, -1);
      } else if (newPosition < oldPosition) {
        const listItemsToModify = listItems
          .slice(newPosition, oldPosition + 1)
          .filter(
            (listItem: AdminListItemModel) => listItem.id != this.listItem.id,
          );
        this.shiftPositions(listItemsToModify, +1);
      }
      this.$store.commit('UPDATE_ENTITY_PROP', {
        id: this.listItem.id,
        entity: 'list_items',
        propToUpdate: 'position',
        value: newPosition,
      });
    },
    videoDuration: function(duration: number) {
      return duration
        ? ` ${Math.trunc(duration / 60)}
        minuto(s) e 
        ${duration % 60}
        segundo(s)`
        : '-';
    },
  },
});
